import { render, staticRenderFns } from "./NewOffer.vue?vue&type=template&id=bfd2f418&scoped=true"
import script from "./NewOffer.vue?vue&type=script&lang=js"
export * from "./NewOffer.vue?vue&type=script&lang=js"
import style0 from "./NewOffer.vue?vue&type=style&index=0&id=bfd2f418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd2f418",
  null
  
)

export default component.exports